import { render, staticRenderFns } from "./BannerClassListView.vue?vue&type=template&id=86455080&scoped=true"
import script from "./BannerClassListView.vue?vue&type=script&lang=js"
export * from "./BannerClassListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86455080",
  null
  
)

export default component.exports